import { Box, Typography } from '@mui/material'
import React from 'react'

import { getDayMonth, isCurrentDateBefore } from '../../utils/date-utils'
import { CustomStepper, getFinalIcon, getQualificationIcon, getSubmissionIcon } from '../_common/CustomStepper'

const resolveTournamentStep = (tournament) => {
  const isBeforeSignupEnd = isCurrentDateBefore(tournament.time_signup_end)
  if (isBeforeSignupEnd) return 0
  return 1
}

const TournamentStepper = ({ tournament }) => {
  const activeStep = resolveTournamentStep(tournament)
  const stepsListConfig = [
    {
      value: 0,
      title: 'Registration',
      startDate: tournament.time_signup_start,
      endDate: tournament.time_signup_end,
      icon: getSubmissionIcon(activeStep),
    },
    {
      value: 1,
      title: 'Start',
      endDate: tournament.time_tournament_start,
      icon: getQualificationIcon(activeStep),
    },
    {
      value: 2,
      title: 'Finished',
      endDate: tournament.time_tournament_end,
      icon: getFinalIcon(activeStep),
    },
  ]

  return (
    <CustomStepper
      activeStep={activeStep}
      stepsListConfig={stepsListConfig}
    />
  )
}

const TournamentMobileStepper = ({ tournament }) => {
  const activeStepIndex = resolveTournamentStep(tournament)
  const activeStep =
    activeStepIndex === 0
      ? {
          value: 0,
          title: 'Registration',
          startDate: tournament.time_signup_start,
          endDate: tournament.time_signup_end,
          icon: getSubmissionIcon(activeStepIndex),
        }
      : {
          value: 1,
          title: 'Start',
          endDate: tournament.time_tournament_start,
          icon: getQualificationIcon(activeStepIndex),
        }

  return (
    <Box display="grid">
      <Typography
        color="text.secondary"
        variant="h6"
      >
        {activeStep.title}
      </Typography>
      <Typography
        color="text.tertiary"
        variant="caption"
      >
        {!!activeStep.startDate
          ? `${getDayMonth(activeStep.startDate)} - ${getDayMonth(activeStep.endDate)}`
          : getDayMonth(activeStep.endDate)}
      </Typography>
    </Box>
  )
}

export { TournamentMobileStepper, TournamentStepper }
